export default {
    // DESENV
    // apiURL: 'http://desenv.consorciosapi.saude.ba.gov.br/api',
    //  captchaURL: 'http://desenv.consorciosapi.saude.ba.gov.br/captcha/api/default',
    //  baseUrlSite: 'http://desenv.consorciosapi.saude.ba.gov.br/',
    // docURL: 'http://desenv.consorciosapi.saude.ba.gov.br/api/document',
    // docItemsURL: 'http://desenv.consorciosapi.saude.ba.gov.br/api/folder',
    // docYearsURL: 'http://desenv.consorciosapi.saude.ba.gov.br/api/document-years',

    // HOMOLOGA
    // apiURL: 'http://homologa.consorcios.saude.ba.gov.br/api',
    // baseUrlSite: 'http://homologa.consorcios.saude.ba.gov.br/',
    // captchaURL: 'http://homologa.consorcios.saude.ba.gov.br/captcha/api/default',
    // docURL: 'http://homologa.consorcios.saude.ba.gov.br/api/document',
    // docItemsURL: 'http://homologa.consorcios.saude.ba.gov.br/api/folder',
    // docYearsURL: 'http://homologa.consorcios.saude.ba.gov.br/api/document-years',

    // // PRODUCAO
    apiURL: 'https://consorcios.saude.ba.gov.br/api',
    captchaURL: 'https://consorcios.saude.ba.gov.br/captcha/api/default',
    baseUrlSite: 'https://consorcios.saude.ba.gov.br/',
    docURL: 'https://consorcios.saude.ba.gov.br/api/document',
    docItemsURL: 'https://consorcios.saude.ba.gov.br/api/folder',
    docYearsURL: 'https://consorcios.saude.ba.gov.br/api/document-years',
    // ID de contratos no BD de Produção é 41 mas em Desenv é 7 
    // por isso a alteraçaõ do ID no codigo para em produção funcionar

    // alterado para homologa pois vai ser renomeado com o nome de homologa

    //// LOCAL
    // apiURL: 'http://localhost:8000/api',
    // baseUrlSite: 'http://localhost:8000/', 
    // // captchaURL: 'http://localhost:8000/captcha/api/default',
    // docURL: 'http://localhost:8000/api/document',
    // docItemsURL: 'http://localhost:8000/api/folder',
    // docYearsURL: 'http://localhost:8000/api/document-years',
}